import React from 'react';
import { Flex, Text, H3, Image, Box } from '@opendoor/bricks/core';
import imgixUrl from '@opendoor/bricks/helpers/imgixUrl';
import { CakeContentCard } from 'sellDirect/components/legacy/layout/CakeContentWrapper';
import { SCHEDULE_EXTERIOR_ASSESSMENT_IMG } from 'shared/helpers/constants';

const TITLE = 'Schedule your exterior assessment';
const SUB_TITLE =
  "We'll send out a member of our team to assess your home's exterior. After that, we'll have what we need to prepare your final offer.";

const AGENT_TITLE = 'Schedule the exterior assessment';
const AGENT_SUB_TITLE =
  "We'll send out a member of our team to assess the exterior of your client's home. After that, we'll have what we need to prepare your client's final offer.";

const IN_PERSON_TITLE = 'Schedule your home assessment';
const IN_PERSON_SUB_TITLE =
  'We’ll send out a member of our team to assess your home’s exterior. They will also take a quick look at the inside of your home. After that, we’ll have what we need to prepare your final offer.';

const IN_PERSON_AGENT_TITLE = 'Schedule your client’s home assessment';
const IN_PERSON_AGENT_SUB_TITLE =
  'We’ll send out a member of our team to assess the exterior of your client’s home. They will also take a quick look inside and will need access from you or your client. After that, we’ll have what we need to prepare your client’s final offer.';

const getTitleAndSubtitle = (
  shouldSeeAgentExperience: boolean | undefined,
  isInPersonSseaEnabled: boolean | undefined,
) => {
  let title = shouldSeeAgentExperience ? AGENT_TITLE : TITLE;
  let subTitle = shouldSeeAgentExperience ? AGENT_SUB_TITLE : SUB_TITLE;

  if (isInPersonSseaEnabled) {
    title = shouldSeeAgentExperience ? IN_PERSON_AGENT_TITLE : IN_PERSON_TITLE;
    subTitle = shouldSeeAgentExperience ? IN_PERSON_AGENT_SUB_TITLE : IN_PERSON_SUB_TITLE;
  }
  return { title, subTitle };
};

/** TODO: Add documentation */
export const ScheduleHeader: React.FC<{
  errorMessage?: string;
  shouldSeeAgentExperience?: boolean;
  isInPersonSseaEnabled?: boolean;
}> = ({ errorMessage, shouldSeeAgentExperience, isInPersonSseaEnabled }) => {
  const { title, subTitle } = getTitleAndSubtitle(shouldSeeAgentExperience, isInPersonSseaEnabled);

  return (
    <CakeContentCard thickBorder forceBorder isInlay>
      <Flex justifyContent="space-between" alignItems="flex-start" pt={[6, 8]}>
        <Box mr={4}>
          {errorMessage && (
            <Text mb={5} color="red50">
              {errorMessage}
            </Text>
          )}
          <H3 fontSize={['s3', 'UNSAFE_h1Mobile']} mb={[6, 8]}>
            {title}
          </H3>
          <Text fontSize="s1" lineHeight="s0" color="neutrals90">
            {subTitle}
          </Text>
        </Box>
        <Image src={imgixUrl(SCHEDULE_EXTERIOR_ASSESSMENT_IMG)} alt="" />
      </Flex>
    </CakeContentCard>
  );
};
